// 六十四卦数据结构
const HEXAGRAMS = {
  "1": {
    number: 1,
    name: "乾",
    title: "乾为天",
    binary: "111111",
    symbol: "䷀",
    meaning: "元亨利贞",
    description: "天行健，君子以自强不息",
    attributes: {
      nature: "天",
      element: "金",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初九：潜龙，勿用。",
      two: "九二：见龙在田，利见大人。",
      three: "九三：君子终日乾乾，夕惕若，厉，无咎。",
      four: "九四：或跃在渊，无咎。",
      five: "九五：飞龙在天，利见大人。",
      six: "上九：亢龙有悔。"
    }
  },
  "2": {
    number: 2,
    name: "坤",
    title: "坤为地",
    binary: "000000",
    symbol: "䷁",
    meaning: "元亨, 后不利師，大无利",
    description: "地势坤，君子以厚德载物",
    attributes: {
      nature: "地",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初六：履霜，坚冰至。",
      two: "六二：直，方，大，不习无不利。",
      three: "六三：含章可贞。或从王事，无成有终。",
      four: "六四：括囊；无咎，无誉。",
      five: "六五：黄裳，元吉。",
      six: "上六：龙战于野，其血玄黄。"
    }
  },
  "3": {
    number: 3,
    name: "屯",
    title: "水雷屯",
    binary: "010001",
    symbol: "䷂",
    meaning: "元亨,利贞",
    description: "云雷屯，君子以经纶",
    attributes: {
      nature: "水雷",
      element: "水",
      direction: "东北",
      season: "春"
    },
        yaoTexts: {
      one: "初九：磐桓；利居贞，利建侯。",
      two: "六二：屯如邅如，乘马班如。匪寇婚媾，女子贞不字，十年乃字。",
      three: "六三：即鹿无虞，惟入于林中，君子几不如舍，往吝。",
      four: "六四：乘马班如，求婚媾，往吉，无不利。",
      five: "九五：屯其膏，小贞吉，大贞凶。",
      six: "上六：乘马班如，泣血涟如。"
    }
  },
  "4": {
    number: 4,
    name: "蒙",
    title: "山水蒙",
    binary: "100010",
    symbol: "䷃",
    meaning: "亨, 包蒙, 初吉, 后凶",
    description: "山下出泉，君子以果行育德",
    attributes: {
      nature: "山水",
      element: "水",
      direction: "东",
      season: "春"
    },
        yaoTexts: {
      one: "初六：发蒙，利用刑人，用说桎梏，以往吝。",
      two: "九二：包蒙吉；纳妇吉；子克家。",
      three: "六三：勿用娶女；见金夫，不有躬，无攸利。",
      four: "六四：困蒙，吝。",
      five: "六五：童蒙，吉。",
      six: "上九：击蒙；不利为寇，利御寇。"
    }
  },
  "5": {
    number: 5,
    name: "需",
    title: "水天需",
    binary: "010111",
    symbol: "䷄",
    meaning: "有孚, 元吉, 无咎",
    description: "云上于天，君子以饮食宴乐",
    attributes: {
      nature: "水天",
      element: "水",
      direction: "东南",
      season: "夏"
    },
        yaoTexts: {
      one: "初九：需于郊。利用恒，无咎。",
      two: "九二：需于沙。小有言，终吉。",
      three: "九三：需于泥，致寇至。",
      four: "六四：需于血，出自穴。",
      five: "九五：需于酒食，贞吉。",
      six: "上六：入于穴，有不速之客三人来，敬之终吉。"
    }
  },
  "6": {
    number: 6,
    name: "讼",
    title: "天水讼",
    binary: "111010",
    symbol: "䷅",
    meaning: "有孚, 結其心",
    description: "天与水违行，君子以作事谋始",
    attributes: {
      nature: "天水",
      element: "金",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初六：不永所事，小有言，终吉。",
      two: "九二：不克讼，归而逋，其邑人三百户，无眚。",
      three: "六三：食旧德，贞厉，终吉，或从王事，无成。",
      four: "九四：不克讼，复即命渝，安贞吉。",
      five: "九五：讼元吉。",
      six: "上九：或锡之鞶带，终朝三褫之。"
    }
  },
  "7": {
    number: 7,
    name: "师",
    title: "地水师",
    binary: "000010",
    symbol: "䷆",
    meaning: "贞, 丈人吉,无咎",
    description: "地承天而水承地，君子以容民畜众",
    attributes: {
      nature: "地水",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初六：师出以律，否臧凶。",
      two: "九二：在师中吉，无咎，王三锡命。",
      three: "六三：师或舆尸，凶。",
      four: "六四：师左次，无咎。",
      five: "六五：田有禽，利执言，无咎。长子帅师，弟子舆尸，贞凶。",
      six: "上六：大君有命，开国承家，小人勿用。"
    }
  },
  "8": {
    number: 8,
    name: "比",
    title: "水地比",
    binary: "010000",
    symbol: "䷇",
    meaning: "吉, 原筮, 元永贞, 无咎",
    description: "比之自内，君子以入于其宫",
    attributes: {
      nature: "水地",
      element: "水",
      direction: "东北",
      season: "春"
    },
        yaoTexts: {
      one: "初六：有孚，比之，无咎。有孚盈缶，终来有他，吉。",
      two: "六二：比之自内，贞吉。",
      three: "六三：比之匪人。",
      four: "六四：外比之，贞吉。",
      five: "九五：显比，王用三驱，失前禽。邑人不诫，吉。",
      six: "上六：比之无首，凶。"
    }
  },
  "9": {
    number: 9,
    name: "小畜",
    title: "风天小畜",
    binary: "110111",
    symbol: "䷈",
    meaning: "亨, 密云不雨, 自我西郊",
    description: "风行天上，君子以懿文德",
    attributes: {
      nature: "风天",
      element: "风",
      direction: "东",
      season: "春"
    },
        yaoTexts: {
      one: "初九：复自道，何其咎，吉。",
      two: "九二：牵复，吉。",
      three: "九三：舆说辐，夫妻反目。",
      four: "六四：有孚，血去惕出，无咎。",
      five: "九五：有孚挛如，富以其邻。",
      six: "上九：既雨既处，尚德载，妇贞厉。月几望，君子征凶。"
    }
  },
  "10": {
    number: 10,
    name: "履",
    title: "天泽履",
    binary: "111011",
    symbol: "䷉",
    meaning: "履虎尾, 不咥人,亨",
    description: "上天下泽，君子以辨上下, 定民志",
    attributes: {
      nature: "天泽",
      element: "金",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初九：素履，往无咎。",
      two: "九二：履道坦坦，幽人贞吉。",
      three: "六三：眇能视，跛能履，履虎尾，咥人，凶。武人为于大君。",
      four: "九四：履虎尾，诉诉，终吉。",
      five: "九五：夬履，贞厉。",
      six: "上九：视履考祥，其旋元吉。"
    }
  },
  "11": {
    number: 11,
    name: "泰",
    title: "天地泰",
    binary: "000111",
    symbol: "䷊",
    meaning: "小往大来, 亨",
    description: "天地交泰, 后以财成天地之道",
    attributes: {
      nature: "天地",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初九：拔茅茹，以其彙，征吉。",
      two: "九二：包荒，用馮河，不遐遺，朋亡，得尚于中行。",
      three: "九三：无平不陂，无往不復，艱貞无咎。勿恤其孚，于食有福。",
      four: "六四：翩翩，不富，以其鄰，不戒以孚。",
      five: "六五：帝乙歸妹，以祉元吉。",
      six: "上六：城復于隍，勿用師。自邑告命，貞吝。"
    }
  },
  "12": {
    number: 12,
    name: "否",
    title: "地天否",
    binary: "111000",
    symbol: "䷋",
    meaning: "否之匪人, 不利君子贞",
    description: "天地不交, 君子以俭德, 阜亨",
    attributes: {
      nature: "天地",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初六：拔茅茹，以其汇，贞吉亨。",
      two: "六二：包承。小人吉，大人否，亨。",
      three: "六三：包羞。",
      four: "九四：有命，无咎，畴离祉。",
      five: "九五：休否，大人吉。其亡其亡，系于苞桑。",
      six: "上九：倾否，先否后喜。"
    }
  },
  "13": {
    number: 13,
    name: "同人",
    title: "天火同人",
    binary: "111101",
    symbol: "䷌",
    meaning: "同人于野, 君子亨",
    description: "天与火交, 君子以类族辨物",
    attributes: {
      nature: "天火",
      element: "火",
      direction: "东北",
      season: "春"
    },
        yaoTexts: {
      one: "初九：同人于门，无咎。",
      two: "六二：同人于宗，吝。",
      three: "九三：伏戎于莽，升其高陵，三岁不兴。",
      four: "九四：乘其墉，弗克攻，吉。",
      five: "九五：同人，先号啕而后笑。大师克相遇。",
      six: "上九：同人于郊，无悔。"
    }
  },
  "14": {
    number: 14,
    name: "大有",
    title: "火天大有",
    binary: "101111",
    symbol: "䷍",
    meaning: "大有, 元亨",
    description: "火在天上, 君子以明明德",
    attributes: {
      nature: "火天",
      element: "火",
      direction: "东",
      season: "春"
    },
        yaoTexts: {
      one: "初九：无交害，匪咎，艰则无咎。",
      two: "六二：同人于宗，吝。",
      three: "九三：公用亨于天子，小人弗克。",
      four: "九四：匪其彭，无咎。",
      five: "六五：厥孚交如，威如；吉。",
      six: "上九：自天佑之，吉无不利。"
    }
  },
  "15": {
    number: 15,
    name: "谦",
    title: "地山谦",
    binary: "000100",
    symbol: "䷎",
    meaning: "亨, 君子有终",
    description: "地中有山, 君子以裒多益寡",
    attributes: {
      nature: "地山",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初六：谦谦君子，用涉大川，吉。",
      two: "六二：鸣谦，贞吉。",
      three: "九三：劳谦，君子有终，吉。",
      four: "六四：无不利，撝谦。",
      five: "六五：不富，以其邻，利用侵伐，无不利。",
      six: "上六：鸣谦，利用行师，征邑国。"
    }
  },
  "16": {
    number: 16,
    name: "豫",
    title: "雷地豫",
    binary: "001000",
    symbol: "䷏",
    meaning: "利建侯, 旅行",
    description: "雷出地奋, 君子以作乐崇德",
    attributes: {
      nature: "雷地",
      element: "雷",
      direction: "东北",
      season: "春"
    },
        yaoTexts: {
      one: "初六：鸣豫，凶。",
      two: "六二：介于石，不终日，贞吉。",
      three: "六三：盱豫，悔。迟有悔。",
      four: "九四：由豫，大有得。勿疑。朋盍簪。",
      five: "六五：贞疾，恒不死。",
      six: "上六：冥豫，成有渝，无咎。"
    }
  },
  "17": {
    number: 17,
    name: "随",
    title: "泽雷随",
    binary: "011001",
    symbol: "䷐",
    meaning: "元亨利贞, 无咎",
    description: "泽中有雷, 君子以向晦入宴息",
    attributes: {
      nature: "泽雷",
      element: "泽",
      direction: "东",
      season: "春"
    },
        yaoTexts: {
      one: "初九：官有渝，贞吉。出门交有功。",
      two: "六二：系小子，失丈夫。",
      three: "六三：系丈夫，失小子。随有求得，利居贞。",
      four: "九四：随有获，贞凶。有孚在道，以明，何咎。",
      five: "九五：孚于嘉，吉。",
      six: "上六：拘系之，乃从维之。王用亨于西山。"
    }
  },
  "18": {
    number: 18,
    name: "蛊",
    title: "山风蛊",
    binary: "100110",
    symbol: "䷑",
    meaning: "元亨, 利涉大川",
    description: "山下有风, 君子以振民育德",
    attributes: {
      nature: "山风",
      element: "山",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初六：干父之蛊，有子，考无咎，厉终吉。",
      two: "九二：干母之蛊，不可贞。",
      three: "九三：干父之蛊，小有悔，无大咎。",
      four: "六四：裕父之蛊，往见吝。",
      five: "六五：干父之蛊，用誉。",
      six: "上九：不事王侯，高尚其事。"
    }
  },
  "19": {
    number: 19,
    name: "临",
    title: "地泽临",
    binary: "000011",
    symbol: "䷒",
    meaning: "元, 亨, 利, 贞",
    description: "泽上有地, 君子以教思无穷",
    attributes: {
      nature: "地泽",
      element: "地",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初九：咸临，贞吉。",
      two: "九二：咸临，吉无不利。",
      three: "六三：甘临，无攸利。既忧之，无咎。",
      four: "六四：至临，无咎。",
      five: "六五：知临，大君之宜，吉。",
      six: "上六：敦临，吉无咎。"
    }
  },
  "20": {
    number: 20,
    name: "观",
    title: "风地观",
    binary: "110000",
    symbol: "䷓",
    meaning: "盥而不荐, 有孚, 悖,终吉",
    description: "风行地上, 君子以省方, 考政",
    attributes: {
      nature: "风地",
      element: "风",
      direction: "东",
      season: "春"
    },
        yaoTexts: {
      one: "初六：童观，小人无咎，君子吝。",
      two: "六二：窥观，利女贞。",
      three: "六三：观我生，进退。",
      four: "六四：观国之光，利用宾于王。",
      five: "九五：观我生，君子无咎。",
      six: "上九：观其生，君子无咎。"
    }
  },
  "21": {
    number: 21,
    name: "噬嗑",
    title: "火雷噬嗑",
    binary: "101001",
    symbol: "䷔",
    meaning: "亨, 利贞",
    description: "雷在火上, 君子以明罚敕法",
    attributes: {
      nature: "火雷",
      element: "火",
      direction: "南",
      season: "夏"
    },
        yaoTexts: {
      one: "初九：屦校灭趾，无咎。",
      two: "六二：噬肤灭鼻，无咎。",
      three: "六三：噬腊肉，遇毒；小吝，无咎。",
      four: "九四：噬乾胏，得金矢，利艰贞，吉。",
      five: "六五：噬乾肉，得黄金，贞厉，无咎。",
      six: "上九：何校灭耳，凶。"
    }
  },
  "22": {
    number: 22,
    name: "贲",
    title: "山火贲",
    binary: "100101",
    symbol: "䷕",
    meaning: "亨, 小利有攸往",
    description: "山下有火, 君子以明庶政",
    attributes: {
      nature: "山火",
      element: "火",
      direction: "东南",
      season: "夏"
    },
        yaoTexts: {
      one: "初九：贲其趾，舍车而徒。",
      two: "六二：贲其须。",
      three: "九三：贲如濡如，永贞吉。",
      four: "六四：贲如皤如，白马翰如，匪寇婚媾。",
      five: "六五：贲于丘园，束帛戋戋，吝，终吉。",
      six: "上九：白贲，无咎。"
    }
  },
  "23": {
    number: 23,
    name: "剥",
    title: "山地剥",
    binary: "100000",
    symbol: "䷖",
    meaning: "不利有攸往",
    description: "山附地上, 君子以厚下安宅",
    attributes: {
      nature: "山地",
      element: "土",
      direction: "西南",
      season: "冬"
    },
        yaoTexts: {
      one: "初六：剥床以足，蔑贞凶。",
      two: "六二：剥床以辨，蔑贞凶。",
      three: "六三：剥之，无咎。",
      four: "六四：剥床以肤，凶。",
      five: "六五：贯鱼，以宫人宠，无不利。",
      six: "上九：硕果不食，君子得舆，小人剥庐。"
    }
  },
  "24": {
    number: 24,
    name: "复",
    title: "地雷复",
    binary: "000001",
    symbol: "䷗",
    meaning: "出入无疾, 朋来无咎",
    description: "雷在地中, 君子以出入劳疾",
    attributes: {
      nature: "地雷",
      element: "雷",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初九：不复远，无祗悔，元吉。",
      two: "六二：休复，吉。",
      three: "六三：频复，厉无咎。",
      four: "六四：中行独复。",
      five: "六五：敦复，无悔。",
      six: "上六：迷复，凶，有灾眚。用行师，终有大败，以其国君，凶；至于十年，不克征。"
    }
  },
  "25": {
    number: 25,
    name: "无妄",
    title: "天雷无妄",
    binary: "111001",
    symbol: "䷘",
    meaning: "元亨, 利贞",
    description: "天雷无妄, 君子以施禄及下",
    attributes: {
      nature: "天雷",
      element: "天",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初九：无妄，往吉。",
      two: "六二：不耕获，不灾畲，则利有攸往。",
      three: "六三：无妄之灾，或系之牛，行人之得，邑人之灾。",
      four: "九四：可贞，无咎。",
      five: "九五：无妄之疾，勿药有喜。",
      six: "上九：无妄，行有眚，无攸利。"
    }
  },
  "26": {
    number: 26,
    name: "大畜",
    title: "山天大畜",
    binary: "100111",
    symbol: "䷙",
    meaning: "利贞, 不家食吉",
    description: "山上有雷, 君子以多识前言往行",
    attributes: {
      nature: "山天",
      element: "山",
      direction: "东北",
      season: "春"
    },
        yaoTexts: {
      one: "初九：有厉利已。",
      two: "九二：舆说輹。",
      three: "九三：良马逐，利艰贞。曰闲舆卫，利有攸往。",
      four: "六四：童牛之牿，元吉。",
      five: "六五：豶豕之牙，吉。",
      six: "上九：何天之衢，亨。"
    }
  },
  "27": {
    number: 27,
    name: "颐",
    title: "山雷颐",
    binary: "100001",
    symbol: "䷚",
    meaning: "贞吉, 习勿学",
    description: "山下有雷, 君子以慎言语",
    attributes: {
      nature: "山雷",
      element: "雷",
      direction: "西北",
      season: "秋"
    },
        yaoTexts: {
      one: "初九：舍尔灵龟，观我朵颐，凶。",
      two: "六二：颠颐，拂经，于丘颐，征凶。",
      three: "六三：拂颐，贞凶，十年勿用，无攸利。",
      four: "六四：颠颐，吉，虎视眈眈，其欲逐逐，无咎。",
      five: "六五：拂经，居贞吉，不可涉大川。",
      six: "上九：由颐，厉吉，利涉大川。"
    }
  },
  "28": {
    number: 28,
    name: "大过",
    title: "泽风大过",
    binary: "011110",
    symbol: "䷛",
    meaning: "栋桡, 利有攸往",
    description: "泽灭木, 君子以独立不惧",
    attributes: {
      nature: "泽风",
      element: "泽",
      direction: "南",
      season: "夏"
    },
        yaoTexts: {
      one: "初六：藉用白茅，无咎。",
      two: "九二：枯杨生稊，老夫得其女妻，无不利。",
      three: "九三：栋桡，凶。",
      four: "九四：栋隆，吉；有它吝。",
      five: "九五：枯杨生华，老妇得士夫，无咎无誉。",
      six: "上六：过涉灭顶，凶，无咎。"
    }
  },
  "29": {
    number: 29,
    name: "坎",
    title: "坎为水",
    binary: "010010",
    symbol: "䷜",
    meaning: "重重险阻",
    description: "习坎，入于坎窞",
    attributes: {
      nature: "水水",
      element: "水水",
      direction: "北/北",
      season: "冬/冬"
    },
        yaoTexts: {
      one: "初六：习坎，入于坎窞，凶。",
      two: "九二：坎有险，求小得。",
      three: "六三：来之坎坎，险且枕，入于坎窞，勿用。",
      four: "六四：樽酒簋贰，用缶，纳约自牖，终无咎。",
      five: "九五：坎不盈，祗既平，无咎。",
      six: "上六：系用徽纆，置于丛棘，三岁不得，凶。"
    }
  },
  "30": {
    number: 30,
    name: "离",
    title: "离为火",
    binary: "101101",
    symbol: "䷝",
    meaning: "丽, 亨, 爻丽, 无咎",
    description: "火炎上, 君子以明德保民",
    attributes: {
      nature: "离为火",
      element: "火",
      direction: "南",
      season: "夏"
    },
        yaoTexts: {
      one: "初九：履错然，敬之无咎。",
      two: "六二：黄离，元吉。",
      three: "九三：日昃之离，不鼓缶而歌，则大耋之嗟，凶。",
      four: "九四：突如其来如，焚如，死如，弃如。",
      five: "六五：出涕沱若，戚嗟若，吉。",
      six: "上九：王用出征，有嘉折首，获匪其丑，无咎。"
    }
  },
  31: {
    number: 31,
    name: '咸',
    title: '泽山咸',
    binary: '011100',
    symbol: '䷞',
    meaning: '感应',
    description: '天地感，而万物化生。',
    attributes: {
        nature: '泽山',
        element: '水土',
        direction: '西南/东北',
        season: '冬/夏'
    },
        yaoTexts: {
      one: "初六，咸其拇。",
      two: "六二，咸其腓，凶，居吉。",
      three: "九三，咸其股，执其随，往吝。",
      four: "九四，贞吉，悔亡，憧憧往来，朋从尔思。",
      five: "九五，咸其脢，无悔。",
      six: "上六，咸其辅颊舌。"
    }
  },
  32: {
    number: 32,
  name: '恒',
  title: '雷风恒',
  binary: '001110',
  symbol: '䷟',
  meaning: '恒久',
  description: '君子以立不易方，志不改。',
  attributes: {
      nature: '雷风',
      element: '木木',
      direction: '东/东南',
      season: '春/春'
  },
      yaoTexts: {
      one: "初六：浚恒，贞凶，无攸利。",
      two: "九二：悔亡。",
      three: "九三：不恒其德，或承之羞，贞吝。",
      four: "九四：田无禽。",
      five: "六五：恒其德，贞，妇人吉，夫子凶。",
      six: "上六：振恒，凶。"
    }
  },
  33: {
    number: 33,
    name: '遯',
    title: '天山遯',
    binary: '111100',
    symbol: '䷠',
    meaning: '退避',
    description: '君子以远小人，不恶而严。',
    attributes: {
        nature: '天山',
        element: '金土',
        direction: '西北/北',
        season: '秋/冬'
    },
        yaoTexts: {
      one: "初六：遯尾，厉，勿用有攸往。",
      two: "六二：执之用黄牛之革，莫之胜说。",
      three: "九三：系遯，有疾厉，畜臣妾吉。",
      four: "九四：好遯，君子吉，小人否。",
      five: "九五：嘉遯，贞吉。",
      six: "上九：肥遯，无不利。"
    }
  },
  34: {
    number: 34,
    name: '大壮',
    title: '雷天大壮',
    binary: '001111',
    symbol: '䷡',
    meaning: '强大',
    description: '君子以非礼勿履。',
    attributes: {
        nature: '雷天',
        element: '木金',
        direction: '东/西北',
        season: '春/秋'
    },
        yaoTexts: {
      one: "初九：壮于趾，征凶，有孚。",
      two: "九二：贞吉。",
      three: "九三：小人用壮，君子用罔，贞厉。羝羊触藩，羸其角。",
      four: "九四：贞吉悔亡，藩决不羸，壮于大舆之輹。",
      five: "六五：丧羊于易，无悔。",
      six: "上六：羝羊触藩，不能退，不能遂，无攸利，艰则吉。"
    }
  },
  35: {
    number: 35,
  name: '晋',
  title: '火地晋',
  binary: '101000',
  symbol: '䷢',
  meaning: '晋升',
  description: '君子以自昭明德。',
  attributes: {
      nature: '火地',
      element: '火土',
      direction: '南/中心',
      season: '夏/土旺'
  },
      yaoTexts: {
      one: "初六：晋如，摧如，贞吉。罔孚，裕无咎。",
      two: "六二：晋如，愁如，贞吉。受兹介福，于其王母。",
      three: "六三：众允，悔亡。",
      four: "九四：晋如硕鼠，贞厉。",
      five: "六五：悔亡，失得勿恤，往吉，无不利。",
      six: "上九：晋其角，维用伐邑，厉吉无咎，贞吝。"
    }
},
36: {
  number: 36,
  name: '明夷',
  title: '地火明夷',
  binary: '000101',
  symbol: '䷣',
  meaning: '光明受伤',
  description: '君子以莅众，用晦而明。',
  attributes: {
      nature: '地火',
      element: '土火',
      direction: '中心/南',
      season: '土旺/夏'
  },
      yaoTexts: {
      one: "初九：明夷于飞，垂其翼。君子于行，三日不食，有攸往，主人有言。",
      two: "六二：明夷，夷于左股，用拯马壮，吉。",
      three: "九三：明夷于南狩，得其大首，不可疾贞。",
      four: "六四：入于左腹，获明夷之心，出于门庭。",
      five: "六五：箕子之明夷，利贞。",
      six: "上六：不明晦，初登于天，后入于地。"
    }
},
37: {
  number: 37,
  name: '家人',
  title: '风火家人',
  binary: '110101',
  symbol: '䷤',
  meaning: '家庭',
  description: '君子以言有物，而行有恒。',
  attributes: {
      nature: '风火',
      element: '木火',
      direction: '东南/南',
      season: '春/夏'
  },
      yaoTexts: {
      one: "初九：闲有家，悔亡。",
      two: "六二：无攸遂，在中馈，贞吉。",
      three: "九三：家人嗃嗃，悔厉吉；妇子嘻嘻，终吝。",
      four: "六四：富家，大吉。",
      five: "九五：王假有家，勿恤，往吉。",
      six: "上九：有孚威如，终吉。"
    }
},
38: {
  number: 38,
  name: '睽',
  title: '火泽睽',
  binary: '101011',
  symbol: '䷥',
  meaning: '乖离',
  description: '小事吉。',
  attributes: {
      nature: '火泽',
      element: '火水',
      direction: '南/西',
      season: '夏/秋'
  },
      yaoTexts: {
      one: "初九：悔亡，丧马勿逐，自复；见恶人无咎。",
      two: "九二：遇主于巷，无咎。",
      three: "六三：见舆曳，其牛掣，其人天且劓，无初有终。",
      four: "九四：睽孤，遇元夫，交孚，厉无咎。",
      five: "六五：悔亡，厥宗噬肤，往何咎。",
      six: "上九：睽孤，见豕负涂，载鬼一车，先张之弧，后说之弧，匪寇婚媾，往遇雨则吉。"
    }
},
39: {
  number: 39,
  name: '蹇',
  title: '水山蹇',
  binary: '010100',
  symbol: '䷦',
  meaning: '困难',
  description: '君子以反身修德。',
  attributes: {
      nature: '水山',
      element: '水土',
      direction: '西/北',
      season: '秋/冬'
  },
      yaoTexts: {
      one: "初六：往蹇，来誉。",
      two: "六二：王臣蹇蹇，匪躬之故。",
      three: "九三：往蹇来反。",
      four: "六四：往蹇来连。",
      five: "九五：大蹇朋来。",
      six: "上六：往蹇来硕，吉；利见大人。"
    }
},
40: {
  number: 40,
  name: '解',
  title: '雷水解',
  binary: '001010',
  symbol: '䷧',
  meaning: '解除',
  description: '君子以赦过宥罪。',
  attributes: {
      nature: '雷水',
      element: '木水',
      direction: '东/西',
      season: '春/秋'
  },
      yaoTexts: {
      one: "初六：无咎。",
      two: "九二：田获三狐，得黄矢，贞吉。",
      three: "六三：负且乘，致寇至，贞吝。",
      four: "九四：解而拇，朋至斯孚。",
      five: "六五：君子维有解，吉；有孚于小人。",
      six: "上六：公用射隼于高墉之上，获之，无不利。"
    }
},
"41": {
  number: 41,
  name: "损",
  title: "山泽损",
  binary: "100011",
  symbol: "䷨",
  meaning: "减少",
  description: "减少以达到平衡。",
  attributes: {
    nature: "山泽",
    element: "土水",
    direction: "东北/东南",
    season: "夏/秋"
  },
      yaoTexts: {
      one: "初九：巳事遄往，无咎，酌损之。",
      two: "九二：利贞，征凶，弗损，益之。",
      three: "六三：三人行，则损一人；一人行，则得其友。",
      four: "六四：损其疾，使遄有喜，无咎。",
      five: "六五：或益之，十朋之龟弗克违，元吉。",
      six: "上九：弗损益之，无咎，贞吉，有攸往，得臣无家。"
    }
},
"42": {
  number: 42,
  name: "益",
  title: "风雷益",
  binary: "110001",
  symbol: "䷩",
  meaning: "增加",
  description: "通过合作和相互支持来增加。",
  attributes: {
    nature: "风雷",
    element: "木木",
    direction: "东南/东",
    season: "春/春"
  },
      yaoTexts: {
      one: "初九：利用为大作，元吉，无咎。",
      two: "六二：或益之，十朋之龟弗克违，永贞吉。王用享于帝，吉。",
      three: "六三：益之用凶事，无咎。有孚中行，告公用圭。",
      four: "六四：中行，告公从。利用为依迁国。",
      five: "九五：有孚惠心，勿问元吉。有孚惠我德。",
      six: "上九：莫益之，或击之，立心勿恒，凶。"
    }
},
"43": {
  number: 43,
  name: "夬",
  title: "泽天夬",
  binary: "011111",
  symbol: "䷪",
  meaning: "决断",
  description: "果断地做出决定。",
  attributes: {
    nature: "泽天",
    element: "水金",
    direction: "西/西北",
    season: "秋/秋"
  },
      yaoTexts: {
      one: "初九：壮于前趾，往不胜为咎。",
      two: "九二：惕号，莫夜有戎，勿恤。",
      three: "九三：壮于頄，有凶。君子夬夬，独行，遇雨，若濡，有愠，无咎。   ",
      four: "九四：臀无肤，其行次且。牵羊悔亡，闻言不信。",
      five: "九五：苋陆夬夬，中行无咎。",
      six: "上六：无号，终有凶。"
    }
},
"44": {
  number: 44,
  name: "姤",
  title: "天风姤",
  binary: "111110",
  symbol: "䷫",
  meaning: "相遇",
  description: "意外的相遇和机会。",
  attributes: {
    nature: "天风",
    element: "金木",
    direction: "西北/东南",
    season: "秋/春"
  },
      yaoTexts: {
      one: "初六：系于金柅，贞吉，有攸往，见凶，羸豕孚踟躅。",
      two: "九二：包有鱼，无咎，不利宾。",
      three: "九三：臀无肤，其行次且，厉，无大咎。   ",
      four: "九四：包无鱼，起凶。",
      five: "九五：以杞包瓜，含章，有陨自天。九五：以杞包瓜，含章，有陨自天。",
      six: "上九：姤其角，吝，无咎。"
    }
},
"45": {
  number: 45,
  name: "萃",
  title: "泽地萃",
  binary: "011000",
  symbol: "䷬",
  meaning: "聚集",
  description: "聚集和团结的力量。",
  attributes: {
    nature: "泽地",
    element: "水土",
    direction: "西/中心",
    season: "秋/土旺"
  },
      yaoTexts: {
      one: "初六：有孚不终，乃乱乃萃，若号一握为笑，勿恤，往无咎。",
      two: "六二：引吉，无咎，孚乃利用禴。",
      three: "六三：萃如，嗟如，无攸利，往无咎，小吝。   ",
      four: "九四：大吉，无咎。",
      five: "九五：萃有位，无咎。匪孚，元永贞，悔亡。",
      six: "上六：赍咨涕洟，无咎。"
    }
},
"46": {
  number: 46,
  name: "升",
  title: "地风升",
  binary: "000110",
  symbol: "䷭",
  meaning: "上升",
  description: "逐步上升和进步。",
  attributes: {
    nature: "地风",
    element: "土木",
    direction: "中心/东南",
    season: "土旺/春"
  },
      yaoTexts: {
      one: "初六：允升，大吉。",
      two: "九二：孚乃利用禴，无咎。",
      three: "九三：升虚邑。   ",
      four: "六四：王用亨于岐山，吉无咎。",
      five: "六五：贞吉，升阶。",
      six: "上六：冥升，利于不息之贞。"
    }
},
"47": {
  number: 47,
  name: "困",
  title: "泽水困",
  binary: "011010",
  symbol: "䷮",
  meaning: "困境",
  description: "面对困境和挑战。",
  attributes: {
    nature: "泽水",
    element: "水水",
    direction: "西/西",
    season: "秋/秋"
  },
      yaoTexts: {
      one: "初六：臀困于株木，入于幽谷，三岁不觌。",
      two: "九二：困于酒食，朱绂方来，利用享祀，征凶，无咎。",
      three: "六三：困于石，据于蒺藜，入于其宫，不见其妻，凶。   ",
      four: "九四：来徐徐，困于金车，吝，有终。",
      five: "九五：劓刖，困于赤绂，乃徐有说，利用祭祀。",
      six: "上六：困于葛藟，于臲卼，曰动悔。有悔，征吉。"
    }
},
"48": {
  number: 48,
  name: "井",
  title: "水风井",
  binary: "010110",
  symbol: "䷯",
  meaning: "井",
  description: "井象征着源源不断的支持和资源。",
  attributes: {
    nature: "水风",
    element: "水木",
    direction: "西/东南",
    season: "秋/春"
  },
      yaoTexts: {
      one: "初六：井泥不食，旧井无禽。",
      two: "九二：井谷射鲋，瓮敝漏。",
      three: "九三：井渫不食，为我心恻，可用汲，王明，并受其福。   ",
      four: "六四：井甃，无咎。",
      five: "九五：井冽，寒泉食。",
      six: "上六：井收勿幕，有孚元吉。"
    }
},
"49": {
  number: 49,
  name: "革",
  title: "泽火革",
  binary: "011101",
  symbol: "䷰",
  meaning: "变革",
  description: "变革和创新。",
  attributes: {
    nature: "泽火",
    element: "水火",
    direction: "西/南",
    season: "秋/夏"
  },
      yaoTexts: {
      one: "初九：巩用黄牛之革。",
      two: "六二：巳日乃革之，征吉，无咎。",
      three: "九三：征凶，贞厉，革言三就，有孚。   ",
      four: "九四：悔亡，有孚改命，吉。",
      five: "九五：大人虎变，未占有孚。",
      six: "上六：君子豹变，小人革面，征凶，居贞吉。"
    }
},
"50": {
  number: 50,
  name: "鼎",
  title: "火风鼎",
  binary: "101110",
  symbol: "䷱",
  meaning: "鼎",
  description: "鼎象征着稳定和滋养。",
  attributes: {
    nature: "火风",
    element: "火木",
    direction: "南/东南",
    season: "夏/春"
  },
      yaoTexts: {
      one: "初六：鼎颠趾，利出否，得妾以其子，无咎。",
      two: "九二：鼎有实，我仇有疾，不我能即，吉。",
      three: "九三：鼎耳革，其行塞，雉膏不食，方雨亏悔，终吉。   ",
      four: "九四：鼎折足，覆公餗，其形渥，凶。",
      five: "六五：鼎黄耳，金铉，利贞。",
      six: "上九：鼎玉铉，大吉，无不利。"
    }
},
"51": {
  number: 51,
  name: "震",
  title: "震为雷",
  binary: "001001",
  symbol: "䷲",
  meaning: "震动",
  description: "震动和警醒。",
  attributes: {
    nature: "",
    element: "木",
    direction: "东",
    season: "春"
  },
      yaoTexts: {
      one: "初九：震来虩虩，后笑言哑哑，吉。",
      two: "六二：震来厉，亿丧贝，跻于九陵，勿逐，七日得。",
      three: "六三：震苏苏，震行无眚。   ",
      four: "九四：震遂泥。",
      five: "六五：震往来厉，亿无丧，有事。",
      six: "上六：震索索，视矍矍，征凶。震不于其躬，于其邻，无咎。婚媾有言。"
    }
},
"52": {
  number: 52,
  name: "艮",
  title: "艮为山",
  binary: "100100",
  symbol: "䷳",
  meaning: "静止",
  description: "静止和内省。",
  attributes: {
    nature: "山",
    element: "土",
    direction: "东北",
    season: "冬"
  },
      yaoTexts: {
      one: "初六：艮其趾，无咎，利永贞。",
      two: "六二：艮其腓，不拯其随，其心不快。",
      three: "九三：艮其限，列其夤，厉薰心。",
      four: "六四：艮其身，无咎。",
      five: "六五：艮其辅，言有序，悔亡。",
      six: "上九：敦艮，吉。"
    }
},
"53": {
  number: 53,
  name: "渐",
  title: "风山渐",
  binary: "110100",
  symbol: "䷴",
  meaning: "渐进",
  description: "逐步发展和进步。",
  attributes: {
    nature: "风山",
    element: "木土",
    direction: "东南/东北",
    season: "春/冬"
  },
      yaoTexts: {
      one: "初六：鸿渐于干，小子厉，有言，无咎。",
      two: "六二：鸿渐于磐，饮食衎衎，吉。",
      three: "九三：鸿渐于陆，夫征不复，妇孕不育，凶；利御寇。",
      four: "六四：鸿渐于木，或得其桷，无咎。",
      five: "九五：鸿渐于陵，妇三岁不孕，终莫之胜，吉。",
      six: "上九：鸿渐于陆，其羽可用为仪，吉。"
    }
},
"54": {
  number: 54,
  name: "归妹",
  title: "雷泽归妹",
  binary: "001011",
  symbol: "䷵",
  meaning: "嫁女",
  description: "婚姻和结合。",
  attributes: {
    nature: "雷泽",
    element: "木水",
    direction: "东/西",
    season: "春/秋"
  },
      yaoTexts: {
      one: "初九：归妹以娣，跛能履，征吉。",
      two: "九二：眇能视，利幽人之贞。",
      three: "六三：归妹以须，反归以娣。",
      four: "九四：归妹愆期，迟归有时。",
      five: "六五：帝乙归妹，其君之袂，不如其娣之袂良，月几望，吉。",
      six: "上六：女承筐无实，士刲羊无血，无攸利。"
    }
},
"55": {
  number: 55,
  name: "丰",
  title: "雷火丰",
  binary: "001101",
  symbol: "䷶",
  meaning: "丰盛",
  description: "丰盛和繁荣。",
  attributes: {
    nature: "雷火",
    element: "木火",
    direction: "东/南",
    season: "春/夏"
  },
      yaoTexts: {
      one: "初九：遇其配主，虽旬无咎，往有尚。",
      two: "六二：丰其蔀，日中见斗，往得疑疾，有孚发若，吉。",
      three: "九三：丰其沛，日中见沫，折其右肱，无咎。",
      four: "九四：丰其蔀，日中见斗，遇其夷主，吉。",
      five: "六五：来章，有庆誉，吉。",
      six: "上六：丰其屋，蔀其家，闚其户，阒其无人，三岁不觌，凶。"
    }
},
"56": {
  number: 56,
  name: "旅",
  title: "火山旅",
  binary: "101100",
  symbol: "䷷",
  meaning: "旅行",
  description: "旅行和漂泊。",
  attributes: {
    nature: "火山",
    element: "火土",
    direction: "南/中心",
    season: "夏/土旺"
  },
      yaoTexts: {
      one: "初六：旅琐琐，斯其所取灾。",
      two: "六二：旅即次，怀其资，得童仆贞。",
      three: "九三：旅焚其次，丧其童仆，贞厉。",
      four: "九四：旅于处，得其资斧，我心不快。",
      five: "六五：射雉一矢亡，终以誉命。",
      six: "上九：鸟焚其巢，旅人先笑后号啕。丧牛于易，凶。"
    }
},
"57": {
  number: 57,
  name: "巽",
  title: "巽为风",
  binary: "110110",
  symbol: "䷸",
  meaning: "顺从",
  description: "顺从和适应。",
  attributes: {
    nature: "风",
    element: "木",
    direction: "东南",
    season: "春"
  },
      yaoTexts: {
      one: "初六：进退，利武人之贞。",
      two: "九二：巽在床下，用史巫纷若，吉，无咎。",
      three: "九三：频巽，吝。",
      four: "六四：悔亡，田获三品。",
      five: "九五：贞吉悔亡，无不利。无初有终，先庚三日，后庚三日，吉。",
      six: "上九：巽在床下，丧其资斧，贞凶。"
    }
},
"58": {
  number: 58,
  name: "兑",
  title: "兑为泽",
  binary: "011011",
  symbol: "䷹",
  meaning: "喜悦",
  description: "喜悦和和谐。",
  attributes: {
    nature: "泽",
    element: "水",
    direction: "西",
    season: "秋"
  },
      yaoTexts: {
      one: "初九：和兑，吉。",
      two: "九二：孚兑，吉，悔亡。",
      three: "六三：来兑，凶。",
      four: "九四：商兑，未宁，介疾有喜。",
      five: "九五：孚于剥，有厉。",
      six: "上六：引兑。"
    }
},
"59": {
  number: 59,
  name: "涣",
  title: "风水涣",
  binary: "110010",
  symbol: "䷺",
  meaning: "涣散",
  description: "涣散和分散。",
  attributes: {
    nature: "风水",
    element: "木水",
    direction: "东南/西",
    season: "春/秋"
  },
      yaoTexts: {
      one: "初六：用拯马壮，吉。",
      two: "九二：涣奔其机，悔亡。",
      three: "六三：涣其躬，无悔。",
      four: "六四：涣其群，元吉。涣有丘，匪夷所思。",
      five: "九五：涣汗其大号，涣王居，无咎。",
      six: "上九：涣其血，去逖出，无咎。"
    }
},
"60": {
  number: 60,
  name: "节",
  title: "水泽节",
  binary: "010011",
  symbol: "䷻",
  meaning: "节制",
  description: "节制和约束。",
  attributes: {
    nature: "水泽",
    element: "水水",
    direction: "西/西",
    season: "秋/秋"
  },
      yaoTexts: {
      one: "初九：不出户庭，无咎。",
      two: "九二：不出门庭，凶。",
      three: "六三：不节若，则嗟若，无咎。",
      four: "六四：安节，亨。",
      five: "九五：甘节，吉；往有尚。",
      six: "上六：苦节，贞凶，悔亡。"
    }
},
"61": {
  number: 61,
  name: "中孚",
  title: "风泽中孚",
  binary: "110011",
  symbol: "䷼",
  meaning: "中孚",
  description: "诚信和忠诚。",
  attributes: {
    nature: "风泽",
    element: "木水",
    direction: "东南/西",
    season: "春/秋"
  },
      yaoTexts: {
      one: "初九：虞吉，有它不燕。",
      two: "九二：鸣鹤在阴，其子和之，我有好爵，吾与尔靡之。",
      three: "六三：得敌，或鼓或罢，或泣或歌。",
      four: "六四：月几望，马匹亡，无咎。",
      five: "九五：有孚挛如，无咎。",
      six: "上九：翰音登于天，贞凶。"
    }
},
"62": {
  number: 62,
  name: "小过",
  title: "雷山小过",
  binary: "001100",
  symbol: "䷽",
  meaning: "小过",
  description: "小的过度和调整。",
  attributes: {
    nature: "雷山",
    element: "木土",
    direction: "东/东北",
    season: "春/冬"
  },
      yaoTexts: {
      one: "初六：飞鸟以凶。",
      two: "六二：过其祖，遇其妣；不及其君，遇其臣；无咎。",
      three: "九三：弗过防之，从或戕之，凶。",
      four: "九四：无咎，弗过遇之。往厉必戒，勿用永贞。",
      five: "六五：密云不雨，自我西郊，公弋取彼在穴。",
      six: "上六：弗遇过之，飞鸟离之，凶，是谓灾眚。"
    }
},
"63": {
  number: 63,
  name: "既济",
  title: "水火既济",
  binary: "010101",
  symbol: "䷾",
  meaning: "已经渡过，成功",
  description: "水火既济：君子以思患而预防之。",
      yaoTexts: {
      one: "初九：曳其轮，濡其尾，无咎。",
      two: "六二：妇丧其茀，勿逐，七日得。",
      three: "九三：高宗伐鬼方，三年克之，小人勿用。",
      four: "六四：繻有衣袽，终日戒。",
      five: "九五：东邻杀牛，不如西邻之禴祭，实受其福。",
      six: "上六：濡其首，厉。"
    }
},
"64": {
  number: 64,
  name: "未济",
  title: "火水未济",
  binary: "101010",
  symbol: "䷿",
  meaning: "尚未渡过，未成功",
  description: "火水未济：君子以慎辨物居方。",
      yaoTexts: {
      one: "初六：濡其尾，吝。",
      two: "九二：曳其轮，贞吉。",
      three: "六三：未济，征凶，利涉大川。",
      four: "九四：贞吉，悔亡，震用伐鬼方，三年有赏于大国。",
      five: "六五：贞吉，无悔，君子之光，有孚，吉。",
      six: "上九：有孚于饮酒，无咎，濡其首，有孚失是。"
    }
}
}

// 八卦数据
const BAGUA = {
  '111': { name: '乾', nature: '天', symbol: '☰' },
  '000': { name: '坤', nature: '地', symbol: '☷' },
  '001': { name: '震', nature: '雷', symbol: '☳' },
  '110': { name: '巽', nature: '风', symbol: '☴' },
  '010': { name: '坎', nature: '水', symbol: '☵' },
  '101': { name: '离', nature: '火', symbol: '☲' },
  '100': { name: '艮', nature: '山', symbol: '☶' },
  '011': { name: '兑', nature: '泽', symbol: '☱' }
}

// 修改工具函数的导出方式
const utils = {
  // 卦象查找函数
  findHexagram: (binary) => HEXAGRAMS[binary],

  // 获取上卦
  getUpperTrigram: (binary) => binary.slice(0, 3),

  // 获取下卦
  getLowerTrigram: (binary) => binary.slice(3),

  // 根据卦序获取卦象
  getHexagramByNumber: (number) => {
    return Object.values(HEXAGRAMS).find(hex => hex.number === number)
  },

  // 根据卦名获取卦象
  getHexagramByName: (name) => {
    return Object.values(HEXAGRAMS).find(hex => hex.name === name)
  },

  // 获取卦象的完整信息
  getHexagramInfo: (binary) => {
    const hexagram = HEXAGRAMS[binary]
    if (!hexagram) return null

    const upperTrigram = BAGUA[utils.getUpperTrigram(binary)]
    const lowerTrigram = BAGUA[utils.getLowerTrigram(binary)]

    return {
      ...hexagram,
      upperTrigram,
      lowerTrigram
    }
  },

  // 获取所有卦象
  getAllHexagrams: () => Object.values(HEXAGRAMS),

  // 获取所有八卦
  getAllTrigrams: () => Object.values(BAGUA)
}

// 导出工具函数
export const {
  findHexagram,
  getUpperTrigram,
  getLowerTrigram,
  getHexagramByNumber,
  getHexagramByName,
  getHexagramInfo,
  getAllHexagrams,
  getAllTrigrams
} = utils

// 统一导出数据结构（只导出一次）
export { HEXAGRAMS, BAGUA }
